// immutable
import { fromJS } from "immutable"
// app
import * as types from "./types.js"
import { CLEAR_ERROR } from "actions/types.js"


const initialState = fromJS({
    error: false,
    fetching: false,
    id: 0,
    name: "",
    email: "",
    since: "",
    personid: 0,
    admin: 0,
    active: 0
})

export function fetching(state) {
    if (!state) return false
    if (!state.get) return false
    return state.get("fetching", false)
}

export function error(state) {
    if (!state) return false
    if (!state.get) return false
    const error = state.get("error", false)
    if (error === false) return false
    return error
}

export default function(state = initialState, action) {
    switch(action.type) {
        // request
        case types.LOGIN_REQUEST:
        case types.TOKEN_REQUEST:
        case types.CHANGE_PASSWORD_REQUEST:
        case types.RESET_PASSWORD_REQUEST:
        case types.SIGNUP_REQUEST:
        case types.DELETE_PROFILE_REQUEST:
            return state.set("fetching", true)
        // received
        case types.LOGIN_RECEIVED:
        case types.TOKEN_RECEIVED:
        case types.CHANGE_PASSWORD_RECEIVED:
        case types.RESET_PASSWORD_RECEIVED:
        case types.SIGNUP_RECEIVED:
            return state.withMutations(s => s
                .merge(action.payload)
                .set("fetching", false)
            )
        case types.LOGOUT:
        case types.DELETE_PROFILE_RECEIVED:
            return initialState
        // error
        case types.LOGIN_ERROR:
        case types.TOKEN_ERROR:
            sessionStorage.removeItem("token")
            return state.withMutations(s => s
                .set("error", action.payload)
                .set("fetching", false)
            )
        case types.CHANGE_PASSWORD_ERROR:
        case types.RESET_PASSWORD_ERROR:
        case types.SIGNUP_ERROR:
        case types.DELETE_PROFILE_ERROR:
            return state.withMutations(s => s
                .set("error", action.payload)
                .set("fetching", false)
            )
        case CLEAR_ERROR:
            return state.delete("error")
        // DEFAULT
        default:
            return state
    }
}



/** WEBPACK FOOTER **
 ** ./src/actions/user/reducer.js
 **/